export const HERO_GRADIENT_PRESETS: Record<string, string> = {
  'Dark from left': 'linear-gradient(90deg, rgba(0, 0, 0, 0.65) 0%, rgba(0, 0, 0, 0.1) 70%)',
  'Dark from right': 'linear-gradient(270deg, rgba(0, 0, 0, 0.65) 0%, rgba(0, 0, 0, 0.1) 70%)',
  'Dark from top': 'linear-gradient(180deg, rgba(0, 0, 0, 0.65) 0%, rgba(0, 0, 0, 0.05) 70%)',
  'Dark from bottom': 'linear-gradient(0deg, rgba(0, 0, 0, 0.65) 0%, rgba(0, 0, 0, 0.05) 70%)',
  'Soft dark': 'linear-gradient(135deg, rgba(0, 0, 0, 0.45) 0%, rgba(0, 0, 0, 0.2) 100%)',
  'Light from left':
    'linear-gradient(90deg, rgba(255, 255, 255, 0.72) 0%, rgba(255, 255, 255, 0.1) 70%)',
  'Light from right':
    'linear-gradient(270deg, rgba(255, 255, 255, 0.72) 0%, rgba(255, 255, 255, 0.1) 70%)',
  'Light from top':
    'linear-gradient(180deg, rgba(255, 255, 255, 0.72) 0%, rgba(255, 255, 255, 0.1) 70%)',
  'Light from bottom':
    'linear-gradient(0deg, rgba(255, 255, 255, 0.72) 0%, rgba(255, 255, 255, 0.1) 70%)',
  'Soft light':
    'linear-gradient(135deg, rgba(255, 255, 255, 0.55) 0%, rgba(255, 255, 255, 0.2) 100%)',
  DARK_LEFT: 'linear-gradient(90deg, rgba(0, 0, 0, 0.65) 0%, rgba(0, 0, 0, 0.1) 70%)',
  DARK_RIGHT: 'linear-gradient(270deg, rgba(0, 0, 0, 0.65) 0%, rgba(0, 0, 0, 0.1) 70%)',
  DARK_TOP: 'linear-gradient(180deg, rgba(0, 0, 0, 0.65) 0%, rgba(0, 0, 0, 0.05) 70%)',
  DARK_BOTTOM: 'linear-gradient(0deg, rgba(0, 0, 0, 0.65) 0%, rgba(0, 0, 0, 0.05) 70%)',
  SOFT_DARK: 'linear-gradient(135deg, rgba(0, 0, 0, 0.45) 0%, rgba(0, 0, 0, 0.2) 100%)',
  LIGHT_LEFT: 'linear-gradient(90deg, rgba(255, 255, 255, 0.72) 0%, rgba(255, 255, 255, 0.1) 70%)',
  LIGHT_RIGHT:
    'linear-gradient(270deg, rgba(255, 255, 255, 0.72) 0%, rgba(255, 255, 255, 0.1) 70%)',
  LIGHT_TOP: 'linear-gradient(180deg, rgba(255, 255, 255, 0.72) 0%, rgba(255, 255, 255, 0.1) 70%)',
  LIGHT_BOTTOM: 'linear-gradient(0deg, rgba(255, 255, 255, 0.72) 0%, rgba(255, 255, 255, 0.1) 70%)',
  SOFT_LIGHT:
    'linear-gradient(135deg, rgba(255, 255, 255, 0.55) 0%, rgba(255, 255, 255, 0.2) 100%)',
};

export function resolveHeroGradient(gradient?: string): string | undefined {
  if (!gradient || gradient === 'None' || gradient === 'NONE') {
    return undefined;
  }
  if (gradient.includes('gradient(')) {
    return gradient;
  }
  return HERO_GRADIENT_PRESETS[gradient];
}
